import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	organizationId: string
	isVerified: boolean
}

export async function organizationVerifyApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/organization/verify/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	return await requester.sendRequest(payload, token)
}
